<div class="row">
    <div class="col-xs-12">
        <div class="card card--box card--box--dashboard">
            <div class="card-block card--box--dashboard__block">
                <div class="mx-auto card--box--dashboard__block__header">
                    <h2>
                        {{ 'Assistant component not used anymore' | translate }}
                    </h2>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mr-t--md mr-b--md">
    <div class="col-xs-12">
    </div>
</div>
